import { Platform } from 'react-native';
import {
  isDesktopBrowser,
  isMobileBrowser,
  isWeb,
} from 'shared/constants/platform';

type WebContext = 'mobile_web' | 'desktop_web' | undefined;

const getWebContext = (): WebContext => {
  if (!isWeb) {
    return undefined;
  }
  if (isMobileBrowser) {
    return 'mobile_web';
  }
  if (isDesktopBrowser) {
    return 'desktop_web';
  }
  return undefined;
};

const omitUndefined = <TProperties extends object>(properties: TProperties) =>
  Object.fromEntries(
    Object.entries(properties).filter(([, value]) => value !== undefined),
  ) as TProperties;

export const enrich = <TProperties extends object>(
  properties: TProperties,
): TProperties &
  Record<string, unknown> & {
    platform: 'android' | 'ios' | 'web';
    web_context?: WebContext;
  } => {
  const enriched = {
    ...omitUndefined(properties),
    platform: Platform.OS as 'android' | 'ios' | 'web',
  };

  const webContext = getWebContext();
  if (webContext) {
    return { ...enriched, web_context: webContext };
  }

  return enriched;
};
